"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var colors = _tokens.default.colors; // eslint-disable-next-line react/prop-types

var SpinnerSvg = function SpinnerSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      theme = _ref.theme,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    className: className,
    viewBox: "0 0 100 100",
    width: width,
    height: height,
    focusable: "false",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    d: "M0 0h100v100H0z"
  }), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(84 50)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(45 -52.355 126.397)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0.12s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0.12s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(90 -17 67)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0.25s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0.25s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(135 -2.355 42.397)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0.37s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0.37s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(180 8 25)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0.5s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0.5s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(-135 18.355 7.603)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0.62s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0.62s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(-90 33 -17)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0.75s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0.75s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(-45 68.355 -76.397)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    r: "8",
    fill: colors.legacy[color] || color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".1",
    begin: "0.87s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: "1.5",
    to: "1",
    begin: "0.87s",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
};

var Spinner = (0, _styledComponents.default)(SpinnerSvg).withConfig({
  displayName: "Spinner",
  componentId: "sc-mj18q5-0"
})(["", " ", ""], _styledSystem.color, _styledSystem.layout);
Spinner.defaultProps = {
  color: "" + colors.white,
  height: 14,
  width: 14
};
var _default = Spinner;
exports.default = _default;